import { type LocaleDefinition } from '@solinkcorp/locale';
import escapeRegExp from 'lodash/escapeRegExp';

export function generateSearchRegex(sourceSearchString: string): RegExp | undefined {
  // We only allow boolean operators AND, OR and NOT
  // We automatically wrap phrases in double quotes (and search with OR in brackets)
  if (!sourceSearchString) {
    return undefined;
  }
  const searchString = sourceSearchString
    // Strip starting and ending bracket (only for OR precedence usage)
    .replace(/^\((.*)([^\\])\)$/, '$1$2')
    // Remove NOT phrases, since we would effectively have to highlight everything else
    .replace(/(NOT\s"[^"]+"|NOT\s[^\s]+)/g, '');

  let searchTerms: string[] = [];

  searchString.split(/(\sAND\s|\sOR\s)/).forEach((term) => {
    if (!/^(\sAND\s|\sOR\s)$/.test(term)) {
      const parsedStr = term
        // Strip starting and ending double quotes (for ES phrases)
        .replace(/^"(.*)([^\\])"$/, '$1$2')
        // Strip ending wildcard
        .replace(/\*$/, '')
        // Handle ES reserved characters: + - = && || ! ( ) { } [ ] ^ " ~ * ? : \ /
        // If at start or end strip them away (ES ignores these)
        .replace(/^(\\(\+|-|=|&{2}|\|{2}|!|\(|\)|\{|\}|\[|\]|\^|"|~|\*|\?|:|\\|\/))+/, '')
        .replace(/(\\(\+|-|=|&{2}|\|{2}|!|\(|\)|\{|\}|\[|\]|\^|"|~|\*|\?|:|\\|\/))+$/, '')
        // Otherwise remove escape character
        .replace(/\\(\+|-|=|&{2}|\|{2}|!|\(|\)|\{|\}|\[|\]|\^|"|~|\*|\?|:|\\|\/)/g, '$1');

      searchTerms.push(escapeRegExp(parsedStr));
    }
  });

  searchTerms = searchTerms.filter((term) => !!term);

  return searchTerms.length > 0 ? new RegExp(`(${searchTerms.join('|')})`, 'gi') : undefined;
}

export function getMathSymbolLabels(locale: LocaleDefinition) {
  return {
    '=': `${locale.general.equalTo} =`,
    '>': `${locale.general.greaterThan} >`,
    '>=': `${locale.general.equalOrGreaterThan} >=`,
    '<': `${locale.general.lessThan} <`,
    '<=': `${locale.general.equalOrLessThan} <=`,
  };
}
